import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { L10N_LOCALE } from 'angular-l10n';
import { SharedModule } from 'src/app/shared/shared.module';
import { FileDeleteJob, FilesViewContext } from '../file-view-context';
import { FilesDataSource } from '../files-datasource';
import { FormControl } from '@angular/forms';
import { FilesSearchAndSortComponent } from '../files-search-and-sort/files-search-and-sort.component';
import { Sort } from '@angular/material/sort';
import { FileModel } from 'src/app/hickory-api';

@Component({
  selector: 'app-files-table',
  imports: [FilesSearchAndSortComponent, MatButtonModule, MatIconModule, SharedModule],
  templateUrl: './files-table.component.html',
  styleUrl: './files-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilesTableComponent {
  public viewContext = input.required<FilesViewContext>();
  public datasource = input.required<FilesDataSource>();
  public fileSearch = input.required<FormControl>();
  public deleteJob = input<FileDeleteJob | null>(null);
  public locale = inject(L10N_LOCALE);
  
  protected deleteSelected() {
    this.viewContext().deleteSelected.emit();
  }

  protected onSortChange(event: Sort) {
    const sortField = event.active as keyof FileModel;
    const sortDirection = (event.direction as Sort['direction']) || 'asc';
    if (!sortField) return;
    // Update the view context and datasource sorting without reloading data
    this.viewContext().update({ sortField, sortDirection });
    this.datasource().sortWithoutLoad(sortField, sortDirection);
  }
}
